import { Dispatch, SetStateAction } from "react";

interface HandleAuthorizationParams {
  orders: any[] | any;
  profile: any;
  roles: string[];
  signatureData: any;
  setShowSignaturePopup: Dispatch<SetStateAction<boolean>>;
  setShowPreviewPopup: Dispatch<SetStateAction<boolean>>;
  setNoteVisible: Dispatch<SetStateAction<boolean>>;
  setIsPopupOpen: Dispatch<SetStateAction<boolean>>;
}

export function handleAuthorization({
  orders,
  profile,
  roles,
  signatureData,
  setShowSignaturePopup,
  setShowPreviewPopup,
  setNoteVisible,
  setIsPopupOpen,
}: HandleAuthorizationParams) {
  
  // If no orders are selected, don't show any popup
  if (!orders || (Array.isArray(orders) && orders.length === 0)) {
    return;
  }
  
  let ordersBelongsToLoggedInPhysician = false;
  if (Array.isArray(orders)) {
    ordersBelongsToLoggedInPhysician = orders.every(
      (order: any) =>
        (order?.physician?.email || order?.clinicianInfoPhysician?.email) === profile?.user?.email
    );
  } else {
    ordersBelongsToLoggedInPhysician =
      (orders?.physician?.email || orders?.clinicianInfoPhysician?.email) === profile?.user?.email;
  }
  const isPhysician = roles.includes("Physician");

  if (isPhysician && ordersBelongsToLoggedInPhysician) {
    if (!signatureData) {
      setShowSignaturePopup(true);
    } else {
      setShowPreviewPopup(true);
    }
  } else if (roles.includes("Office Manager")) {
    setNoteVisible(true);
  } else {
    setIsPopupOpen(true);
  }
}
